export default __webpack_public_path__ + "static/media/215415__unfa__ping.bf493823.mp3";